import type { PlotData, PlotType } from 'plotly.js-basic-dist'

type PlotMode =
	| 'lines'
	| 'markers'
	| 'text'
	| 'lines+markers'
	| 'text+markers'
	| 'text+lines'
	| 'text+lines+markers'
	| 'none'
	| 'gauge'
	| 'number'
	| 'delta'
	| 'number+delta'
	| 'gauge+number'
	| 'gauge+number+delta'
	| 'gauge+delta'

export const createTrace = (
	name: string,
	xData: number[],
	yData: number[],
	mode: PlotMode = 'text+lines+markers',
	type: PlotType = 'scatter',
	color: string = '#000000',
	hide: boolean = false,
	showLegend: boolean = true
): PlotData =>
	({
		x: xData,
		y: yData,
		mode,
		type,
		name,
		showlegend: showLegend,
		line: {
			color: hide ? 'transparent' : color
		},
		marker: {
			color: color,
			size: 2
		}
	}) as PlotData
